import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaStar } from "react-icons/fa";
import "./Reviews.css"; // Optional styling
import {reviewURL} from "../../components/assets/constants/Urls/Url"

const GET_REVIEWS_URL = "https://yourapi.com/reviews/"; // Replace with your actual API URL
const POST_REVIEW_URL = "https://yourapi.com/reviews/add"; // Replace with your actual API URL

const Reviews = ({ productId }) => {
  const [reviews, setReviews] = useState([]);
  const [newReview, setNewReview] = useState({ name: "", rating: 5, comment: "" });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [showAllReviews, setShowAllReviews] = useState(false);
  const [showReviewForm, setShowReviewForm] = useState(false);

  // Fetch reviews
  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axios.get(`${reviewURL}/${productId}`);
        setReviews(response.data || []); // Ensure empty array if no data
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    if (productId) {
      fetchReviews();
    }
  }, [productId]); // <- Ensure reviews update when productId changes

  // Handle form input change
  const handleChange = (e) => {
    setNewReview({ ...newReview, [e.target.name]: e.target.value });
  };

  // Handle review submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newReview.name || !newReview.comment) {
      alert("Please fill in all fields.");
      return;
    }

    setSubmitting(true);
    try {
      const response = await axios.post(reviewURL, {
        product_id: productId, // Ensure it matches your DB schema
        ...newReview,
      });

      setReviews([response.data, ...reviews]); // Add new review to the top
      setNewReview({ name: "", rating: 5, comment: "" }); // Reset form
      setShowReviewForm(false); // Hide form after submission
    } catch (err) {
      alert("Failed to submit review.");
    }
    setSubmitting(false);
  };

  return (
    <div className="reviews-container">
      <h3>Customer Reviews</h3>

      {/* Loading/Error Messages */}
      {loading && <p>Loading reviews...</p>}
      

      {/* Show Reviews (Limited Initially) */}
      {reviews.length > 0 ? (
        (showAllReviews ? reviews : reviews.slice(0, 2)).map((review) => (
          <div key={review.id || Math.random()} className="review-card">
            <h5>{review.name}</h5>
            <div className="stars">
              {[...Array(5)].map((_, i) => (
                <FaStar key={i} color={i < review.rating ? "gold" : "gray"} size={24}/>
              ))}
            </div>
            <p>{review.comment}</p>
          </div>
        ))
      ) : (
        <p>No reviews yet. Be the first to write one!</p>
      )}

      <div className="review-button">
        {/* Show More/Less Reviews Button */}
        {reviews.length > 2 && (
          <button onClick={() => setShowAllReviews(!showAllReviews)}>
            {showAllReviews ? "Show Less Reviews" : "Show More Reviews"}
          </button>
        )}

        {/* Add Review Button */}
        <button onClick={() => setShowReviewForm(!showReviewForm)}>
          {showReviewForm ? "Cancel" : "Add a Review"}
        </button>
      </div>

      {/* Submit a Review (Only Shown When User Clicks "Add a Review") */}
      {showReviewForm && (
        <form onSubmit={handleSubmit} className="review-form">
          <input
            type="text"
            name="name"
            value={newReview.name}
            onChange={handleChange}
            placeholder="Your Name"
            required
          />
          <select name="rating" value={newReview.rating} onChange={handleChange}>
            {[5, 4, 3, 2, 1].map((num) => (
              <option key={num} value={num}>
                {num} Stars
              </option>
            ))}
          </select>
          <textarea
            name="comment"
            value={newReview.comment}
            onChange={handleChange}
            placeholder="Write your review..."
            required
          />
          <button type="submit" disabled={submitting}>
            {submitting ? "Submitting..." : "Submit Review"}
          </button>
        </form>
      )}
    </div>
  );
};

export default Reviews;
